import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import axios from "axios";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Card, Popover, TablePagination, Button, Container, Checkbox, FormControl, Grid, Input, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import DropDown from "../assets/svgs/arrow_drop_down.svg";
import DropUp from "../assets/svgs/arrow_drop_up.svg";
import ClearIcon from "../assets/svgs/clear.svg";
import Axios from "axios";

import _ from "lodash";
import "../App.css";
import * as XLSX from "xlsx";
import "../components/loader.css";
import * as images from "../utils/images/images.component";
import { AgentDataDetails } from "./AgentDataDetails";
import "../App.css";
import { log } from "console";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { langVariant } from "./HDFCCredillaDashboard";
import { getLanguageNames } from "./HDFCCredillaAuditSalesDashboard";

  const HdfcCredillaCallsTabDownloadUrl =
    process.env.REACT_APP_BASE_URL + "/Credilla/getCallsDataDownload";
interface Column {
  id:
  |"audio_url"
  |"score"
  |"summary"
  |"score_fatal"
  |"call_time"
  |"CallerID"
  |"call_type" 
  |"EndTime"
  |"StartTime"
  |"disposition"
  |"ucid"
  |"agent"
  |"call_date"
  |"campaign"


  | "loan_eligiblity_criteria_info_check"
  | "clarity_in_speak"
  | "two_ways_communication_check"
  | "documents_info_check"
  | "over_promising_check"
  | "loan_purpose_check"
  | "addressed_cost_concerns"
  | "urgencey_creation"
  | "Active_listeining"
  | "empathy_check"
  | "abusiveness_avoidence_check"
  | "opening_brand_name_check"
  | "opening_selfintro"
  | "agent_summarization_check"
  | "loan_process_info_check"
  | "objection_handling_check"
  | "loan_positioning_check"
  | "callopening_5sec"
  | "followup_call_info_check"
  | "co_applicant_info_check"
  | "rudeness_avoidence_check"
  | "agent_thanking_closing"

  

  |"areas_of_improvement"
  |"language"
  |"training_needs_identification"
    ;
  label: string;
  minWidth?: number;
  align?: "right";
}
interface DataItem {
  [key: string]: string;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 10,
    padding: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    padding: 10,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const columns: readonly Column[] = [

  { id: "audio_url", label: "Audio", minWidth: 150 },
  { id: "score", label: "Score without fatal", minWidth: 100 },
  { id: "score_fatal", label: "score with fatal", minWidth: 100 },
  { id: "call_date", label: "Call Date", minWidth: 100 },
  { id: "StartTime", label: "Start Time", minWidth: 100 },
  { id: "EndTime", label: "End Time", minWidth: 100 },
  { id: "call_type", label: "Call Type", minWidth: 120 },
  { id: "CallerID", label: "Caller ID", minWidth: 100 },
  { id: "call_time", label: "Call Time", minWidth: 100 },
  { id: "language", label: "Language", minWidth: 100 },
  { id: "agent", label: "Agent Name", minWidth: 150 },
  { id: "ucid", label: "UCID", minWidth: 100 },
  { id: "campaign", label: "Campaign", minWidth: 120 },
  { id: "disposition", label: "Disposition", minWidth: 120 },

  { id: "callopening_5sec", label: "Callopening 5sec", minWidth: 170 },
  { id: "opening_selfintro", label: "Opening selfintro", minWidth: 150 },
  { id: "opening_brand_name_check", label: "Opening brand name check", minWidth: 180 },
  { id: "Active_listeining", label: "Active listeining", minWidth: 150 },
  { id: "clarity_in_speak", label: "Clarity In Speech", minWidth: 150 },
  { id: "rudeness_avoidence_check", label: "Rudeness Avoidance", minWidth: 180 },
  { id: "abusiveness_avoidence_check", label: "Abusiveness avoidence check", minWidth: 160 },
  { id: "empathy_check", label: "Empathy Check", minWidth: 150 },
  { id: "loan_eligiblity_criteria_info_check", label: "Loan Eligiblity Criteria Info Check", minWidth: 150 },
  { id: "loan_process_info_check", label: "Loan process info check", minWidth: 150 },
  { id: "co_applicant_info_check", label: "Co applicant info check", minWidth: 250 },
  { id: "documents_info_check", label: "Documents info check", minWidth: 150 },
  { id: "over_promising_check", label: "Over promising check", minWidth: 180 },
  { id: "loan_purpose_check", label: "Loan purpose check", minWidth: 180 },
  { id: "loan_positioning_check", label: "Loan positioning check", minWidth: 150 },
  { id: "followup_call_info_check", label: "Followup call info check", minWidth: 200 },
  { id: "urgencey_creation", label: "Urgencey Creation", minWidth: 150 },
  { id: "addressed_cost_concerns", label: "Addressed cost concerns", minWidth: 160 },
  { id: "objection_handling_check", label: "Objection_ andling check", minWidth: 180 },
  { id: "two_ways_communication_check", label: "Two ways communication check", minWidth: 180 },
  { id: "agent_summarization_check", label: "Agent summarization check", minWidth: 150 },
  { id: "agent_thanking_closing", label: "Agent thanking closing", minWidth: 160 },

  { id: "summary", label: "Summary", minWidth: 250 },
  { id: "training_needs_identification", label: "Training needs Identification", minWidth: 250 },
  { id: "areas_of_improvement", label: "Areas of Improvement", minWidth: 250 },

];

let metaArr: any[] = [];

const getData = () => {
  metaArr = [];
  Object.values(HitsArr).forEach((data) => {
    const obj = JSON.parse(JSON.stringify(data));
    metaArr.push(obj);
  });
  return metaArr;
};

const ArrowRenderer = ({ expanded }: { expanded: boolean }) => (
    <>{expanded ? <img src={DropUp}></img> : <img src={DropDown}></img>}</>
  );

  const CustomClearIcon = () => (
    <div>
      <img src={ClearIcon} className="clear-icon"></img>
    </div>
  );

let HitsArr = {};
let downloadArr: any[] = [];

axios.defaults.headers.common["user"] = localStorage.getItem("user");

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

var objFilter:{data:string[],name:string,labels:string[]}[] = [];
var campaignFinalFilter: any[] = [];
var languageFinalFilter : any[] = [];
var skillFinalFilter : any[] = [];
var callTypeFinalFilter : any[] = [];
var agentFinalFilter: any[] = [];
var dispositionFinalFilter = {};
const scores = ["None", ">", "<"]; 

const  CredillaAuditSalesFiltersURL =
  process.env.REACT_APP_BASE_URL + "/Credilla/openSearchAuditFilters?templateAuditVal=2";
  const CredillaAuditSalesCallsDownloadUrl =
    process.env.REACT_APP_BASE_URL + "/Credilla/getCallsDataDownload";
       const CredillaAuditSalesCallsURL =
  process.env.REACT_APP_BASE_URL + "/Credilla/getCallsData";

export default function CredillaSalesCallsTable() {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [eleRefPoint, setElRefPoint] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>();
  const [downloadData, setDownloadData] = useState<any>();
  const [page, setPage] = React.useState(0);
  const [pageNav, setPageNav] = useState<boolean>(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [agentCountFinal, setAgentCountFinal] = useState<any>([]);
  const [avgDurationFinal, setAvgDurationFinal] = useState<any>([]);                                                                                                                                                                                                                                                                                                                                                                 
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any>([]);
  const [error, setError] = useState('');
 
  const tableRef = useRef(null);
  const [fetchCalls, setFetchCalls] = useState<any>({});
  const [load, setLoadingState] = useState(false); 
  const [campaignAuditOptions, setCampaignAuditOptions] = useState<any[]>([]);
  const [agentAuditOptions, setAgentAuditOptions] = useState<any[]>([]);
  const [dispositionAuditOptions, setDispositionAuditOptions] = useState<any[]>([]);
  const [skillOptions, setSkillOptions] = useState<any[]>([]);
  const [callTypeOptions, setCallTypeOptions] = useState<any[]>([]);
  const [languageAuditOptions, setLanguageAuditOptions] = useState<any[]>([]);
  const [scoreAuditVal, setScoreAuditVal] = useState<string[]>([]);
  const [fatalAuditVal, setFatalAuditVal] = useState<string[]>([]); 
  const [scoreSelected, setScoreSelected] = useState<boolean>(false);
  const [fatalScoreSelected, setFatalScoreSelected] = useState<boolean>(false);
  const [scoreInputVal, setScoreInputVal] = useState<string>("");
  const [fatalInputVal, setFatalInputVal] = useState<string>("");
  const [ucidAuditVal, setUcidAuditVal] = useState<string>("");

  const [callerIDAuditVal, setCallerIDAuditVal] = useState<string>("");
  

  const startDateAuditVal = String(moment("2025-09-04").format("YYYY-MM-DD"));//hdfc_credila moving to VOC, disable future dates
  const emdDateAuditVal = String(moment("2025-09-04").format("YYYY-MM-DD"));//hdfc_credila moving to VOC, disable future dates
  const [startDateAudit, setStartDateAudit] = useState(startDateAuditVal);
  const [endDateAudit, setEndDateAudit] = useState(emdDateAuditVal);
  const [campaignAuditVal, setCampaignAuditVal] = React.useState<any[]>([]);
  const [dispositionAuditVal, setDispositionAuditVal] = React.useState<any[]>([]);
  const [languageAuditVal, setLanguageAduitVal] = React.useState<any[]>([]);
  const [skillAuditVal, setSkillAuditVal] = React.useState<any[]>([]);
  const [agentAuditVal, setAgentAuditVal] = React.useState<any[]>([]);
  const [callTypeAuditVal, setCallTypeAuditVal] = React.useState<any[]>([]);


  
   const handleFromDateChange = (date:any) => {
      setStartDateAudit(date);
      // Check if end date is before start date and set error accordingly
      if (endDateAudit && date > endDateAudit) {
        setError("The start date cannot be after the end date.");
      } else {
        setError('');
      }
    };
  
    const handleToDateChange = (date:any) => {
      setEndDateAudit(date);
      // Check if start date is after end date and set error accordingly
      if (startDateAudit && date < startDateAudit) {
        setError("The end date cannot be before the start date.");
      } else {
        setError('');
      }
    };

     useEffect(() => {
     
       fetchAuditFiltersData();
        fetchOpenSearchCallsData(0);
    }, []);


      function replaceLanguageNames(inputArray: { label: string; value: string }[]) {
        // Create an output array by mapping over the input array
        if (
          _.isArray(inputArray) &&
          !_.isEmpty(inputArray) &&
          !_.isNull(inputArray) &&
          !_.isUndefined(inputArray)
        ) {
          const outputArray = inputArray
            .map((inputItem) => {
              const matchingLang = langVariant.find(
                (langItem) => langItem.label === inputItem.value
              );
              if (matchingLang) {
                return { label: matchingLang.value, value: matchingLang.value };
              } else {
                return null; // Handle cases where no match is found
              }
            })
            .filter((item) => item !== null);
          return outputArray;
        } else {
          return [];
        }
      }
  const selectionList = (arrOfObj:any[]) => {
    let selectionString = "0";
    let selectionArr: string[] = [];
    if (arrOfObj !== undefined && arrOfObj.length > 0) {
      for (const ele of arrOfObj) {
        if(ele.value !== undefined && ele.value !== null){
        selectionArr.push(ele.value);
        }
      }
      selectionString = String(selectionArr);
    } else {
      selectionString = "0";
    }
    return selectionString;
  };
   const findFilters = (name: string,objFilter:{data:string[],name:string,labels:string[]}[]) => {
    for (const key in objFilter) {
      const element = objFilter[key];
      // console.log("Element filter is",element)
      if (element["name"] === name) {
        return element;
      }
    }
    return { data: [], name: "undefined", labels: []};
  };
  const getIntentData = (intent: any[]) => {
    let intentArray = [];
    for (const element of intent) {
      intentArray.push({ label: element, value: element });
    }
    return intentArray;
  };

   const fetchAuditFiltersData = async () => {
      const filtersAudit = await Axios(CredillaAuditSalesFiltersURL);
      // console.log(filtersAudit.data.aggregation);
      sessionStorage.setItem(
        "filtersData",
        JSON.stringify(filtersAudit.data.aggregation)
      );
      if (typeof sessionStorage.filtersData !== "undefined") {
        objFilter = JSON.parse(sessionStorage.filtersData);
      }
      const campaignFilters = findFilters("AuditCampaignCount", objFilter);
      sessionStorage.setItem(
        "campaignFilters",
        JSON.stringify(campaignFilters["labels"])
      );
      if (typeof sessionStorage.campaignFilters !== "undefined") {
        campaignFinalFilter = JSON.parse(sessionStorage.campaignFilters);
      }
      const campaignArr = getIntentData(campaignFinalFilter);
      setCampaignAuditOptions(campaignArr);
  
      const languageFilters = findFilters("AuditLanguageCount", objFilter);
      sessionStorage.setItem(
        "languageFilters",
        JSON.stringify(languageFilters["labels"])
      );
      if (typeof sessionStorage.languageFilters !== "undefined") {
        languageFinalFilter = JSON.parse(sessionStorage.languageFilters);
      }
      const languageNames = getLanguageNames(languageFinalFilter);
      const languageArr = getIntentData(languageNames);
      setLanguageAuditOptions(languageArr);
  
      const agentFilters = findFilters("AuditCallsPerAgent", objFilter);
      sessionStorage.setItem(
        "agentFilters",
        JSON.stringify(agentFilters["labels"])
      );
      if (typeof sessionStorage.agentFilters !== "undefined") {
        agentFinalFilter = JSON.parse(sessionStorage.agentFilters);
      }
      const agentArr = getIntentData(agentFinalFilter);
      setAgentAuditOptions(agentArr);
  
      const dispositionFilters = findFilters("AuditDispositionCount", objFilter);
      sessionStorage.setItem(
        "dispositionFilters",
        JSON.stringify(dispositionFilters["labels"])
      );
      if (typeof sessionStorage.dispositionFilters !== "undefined") {
        dispositionFinalFilter = JSON.parse(sessionStorage.dispositionFilters);
      }
      const dispositionArr = getIntentData(Array.isArray(dispositionFinalFilter) ? dispositionFinalFilter : []);
      setDispositionAuditOptions(dispositionArr);
  
      const skillFilters = findFilters("AuditSkillCount", objFilter);
      sessionStorage.setItem(
        "skillFilters",
        JSON.stringify(skillFilters["labels"])
      );
      if (typeof sessionStorage.skillFilters !== "undefined") {
        skillFinalFilter = JSON.parse(sessionStorage.skillFilters);
      }
      const skillArr = getIntentData(skillFinalFilter);
      setSkillOptions(skillArr);
  
      const callTypeFilters = findFilters("AuditCallTypes", objFilter);
      sessionStorage.setItem(
        "callTypeFilters",
        JSON.stringify(callTypeFilters["labels"])
      );
      if (typeof sessionStorage.callTypeFilters !== "undefined") {
        callTypeFinalFilter = JSON.parse(sessionStorage.callTypeFilters);
      }
      const callTypeArr = getIntentData(callTypeFinalFilter);
      setCallTypeOptions(callTypeArr);
      return {
        agentAuditOptions: agentAuditOptions,
        campaignAuditOptions: campaignAuditOptions,
        dispositionAuditOptions: dispositionAuditOptions,
        languageOptions: languageAuditOptions,
        callTypeOptions : callTypeOptions,
        skillOptions: skillOptions,
      };
    };


     const fetchOpenSearchCallsData = async (fromRec?: number) => {
        setLoadingState(!load);
        // setJsonOpenCallsData([]);
        let langVal =
          !_.isEmpty(languageAuditVal) && !_.isNull(languageAuditVal)
            ? replaceLanguageNames(languageAuditVal)
            : [];
        if (startDateAudit) {
          const response = await axios.get(CredillaAuditSalesCallsURL, {
            params: {
              startDateAudit: String(startDateAudit),
              endDateAudit: String(endDateAudit),
              campaignAuditVal: selectionList(campaignAuditVal),
              callTypeAuditVal: selectionList(callTypeAuditVal),
              agentAuditVal: selectionList(agentAuditVal),
              dispositionAuditVal: selectionList(dispositionAuditVal),
              languageAuditVal: selectionList(langVal),
              skillAuditVal: selectionList(skillAuditVal),
              callerIDAuditVal: !_.isEmpty(callerIDAuditVal) ? String(callerIDAuditVal) : "0",
              ucidAuditVal: !_.isEmpty(ucidAuditVal) ? String(ucidAuditVal) : "0",
              scoreInputVal: scoreInputVal ? scoreInputVal : 0,
              scoreAuditVal: scoreAuditVal ? scoreAuditVal : 0,
              fatalInputVal: fatalInputVal ? fatalInputVal : 0,
              fatalAuditVal: fatalAuditVal ? fatalAuditVal :0,
              size:  rowsPerPage,
              from: fromRec,
               templateAuditVal: 2,
            },
          });
          setFetchCalls(response.data);
          setLoadingState(false);
        } else {
          // const response = await Axios(HdfcCredillaAuditCallsURL);
          // setFetchCalls(response.data);
          setLoadingState(false);
        }
      };



  const convertToTitleCase = (str: string) => {
    return str.replace(/_/g, " ").replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  };
  const convertKeysToTitleCase = (obj: DataItem) => {
    const newObj: DataItem = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[convertToTitleCase(key)] = obj[key];
      }
    }
    return newObj;
  };
  const exportToExcel = (data: any) => {
    // Check if data is defined and is an array
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.error("Invalid or empty data array");
      return;
    }
    // Convert keys to camel case for each object in the array
    const camelCaseData = data.map((obj) => convertKeysToTitleCase(obj));
    // Check if camelCaseData is defined and is an array
    if (
      !camelCaseData ||
      !Array.isArray(camelCaseData) ||
      camelCaseData.length === 0
    ) {
      console.error("Invalid or empty camelCaseData array");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(camelCaseData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // Save the workbook as an XLSX file
    XLSX.writeFile(
      workbook,
      String(localStorage.getItem("user")) + "_Calls.xlsx"
    );
  };
  interface LanguageMapping {
    [key: string]: string;
  }

  const getLanguageName = (languageCode: string): string => {
    const languageMapping: LanguageMapping = {
      "en-IN": "English",
      "ta-IN": "Tamil",
      "ml-IN": "Malayalam",
      "mr-IN": "Marathi",
      "hi-IN": "Hindi",
      "te-IN": "Telugu",
      "kn-IN": "Kannada",
      "gu-IN": "Gujarati",
      // Add more language codes and names as needed
    };
    return languageMapping[languageCode] || "Language not found";
  };

  const getLanguageCode = (languageName: string): string => {
    const languageMapping: LanguageMapping = {
      "English": "en-IN",
      "Tamil": "ta-IN",
      "Malayalam": "ml-IN",
      "Marathi": "mr-IN",
      "Hindi": "hi-IN",
      "Telugu": "te-IN",
      "Kannada": "kn-IN",
      "Gujarati": "gu-IN",
      // Add more language codes and names as needed
    };
    return languageMapping[languageName] || "0";
  };

   const downloadCallData = async () => {
   
      let langVal =
      !_.isEmpty(languageAuditVal) && !_.isNull(languageAuditVal)
        ? replaceLanguageNames(languageAuditVal)
        : [];
          const response = await axios.get(HdfcCredillaCallsTabDownloadUrl, {
            params: {
              startDateAudit: startDateAudit,
              endDateAudit: endDateAudit,
              campaignAuditVal: selectionList(campaignAuditVal),
              callTypeAuditVal: selectionList(callTypeAuditVal),
              agentAuditVal: selectionList(agentAuditVal),
              dispositionAuditVal: selectionList(dispositionAuditVal),
              languageAuditVal: selectionList(langVal),
              skillAuditVal: selectionList(skillAuditVal),
              callerIDAuditVal: !_.isEmpty(callerIDAuditVal) ? String(callerIDAuditVal) : "0",
              ucidAuditVal: !_.isEmpty(ucidAuditVal) ? String(ucidAuditVal) : "0",
              scoreInputVal: scoreInputVal,
              scoreAuditVal: scoreAuditVal,
              fatalInputVal: fatalInputVal,
              fatalAuditVal: fatalAuditVal,
              size: fetchCalls && fetchCalls["dataCount"] ? fetchCalls["dataCount"] : 0,
              from: 0,
              templateAuditVal: 2,
            },
            timeout: 180000,
          });
         return response;
            
      };
  

  const download = async () => {
    try {
      setLoading(true);
      const response = await downloadCallData();
      const data = response && response.data && response.data.Hits;
      downloadArr = [];
      Object.values(data).forEach((rowData: any) => {
        const orderedRow: any = {};
        // Iterate through columns to ensure the order
        columns.forEach((column) => {
          const { id } = column;
          orderedRow[id] = rowData.hasOwnProperty(id)
            ? JSON.parse(JSON.stringify(rowData[id]))
            : undefined;
          // Additional processing for specific columns if needed
          if (id === "language" && orderedRow[id] !== undefined) {
            orderedRow[id] = JSON.parse(
              JSON.stringify(getLanguageName(orderedRow[id]))
            );
          }
          // Add more conditions for other columns if needed
        });
        downloadArr.push(orderedRow);
      });
      console.log(downloadArr);
      setDownloadData(downloadArr);
      exportToExcel(downloadArr);
    } catch (error) {
      downloadArr = [];
      setLoading(false); // Set isLoading to false when done or if an error occurs
      console.log(error);
      window.alert("Error Calling Api to Download");
    } finally {
      downloadArr = [];
      setLoading(false); // Set isLoading to false when done or if an error occurs
    }
  };

  const handleDownload = (e: any) => { 
     download();
  };

  const handleOnPopoverClose = () => {
    setElRefPoint(null);
    setIsPopoverOpen(false);
  };
  const getPopoverContent = () => {
    if (
      !_.isEmpty(responseData) &&
      !_.isEmpty(agentCountFinal) &&
      !_.isEmpty(avgDurationFinal)
    ) {
      return (
        <AgentDataDetails
          getAgentData={[responseData, agentCountFinal, avgDurationFinal]}
        ></AgentDataDetails>
      );
    } else {
      return <AgentDataDetails></AgentDataDetails>;
    }
  };


   const handleChangeDispositionAudit = (selectedOptions: any) => {
    const fil = handleFilters(selectedOptions);
    setDispositionAuditVal(fil);
  };
  const handleChangeLanguageAudit = (event: any) => {
    const fil = handleFilter(event);
    setLanguageAduitVal(fil);
  };
  const handleChangeCampaignAudit = (selectedOptions: any) => {
    const fil = handleFilters(selectedOptions);
    setCampaignAuditVal(fil);
  };
  const handleChangeSkillAudit = (selectedOptions: any) => {
    const fil = handleFilters(selectedOptions);
    setSkillAuditVal(fil);
  };

  const handleChangeFatalAudit = (event: { target: any; }) => {
    const {
      target: { value },
    } = event;
    setFatalAuditVal(event.target.value);
    if (
      event.target.value === "<" ||
      event.target.value === ">" ||
      event.target.value === "="
    ) {
      setFatalScoreSelected(true);
    } else {
      setFatalScoreSelected(false);
    }
  };
  const handleChangeFatalInput = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    setFatalInputVal(event.target.value);
  };

  const handleChangeCallTypeAudit = (selectedOptions: any) => {
    const fil = handleFilters(selectedOptions);
    setCallTypeAuditVal(fil);
  };

  const handleChangeScoreAudit = (event: { target: any; }) => {
    const {
      target: { value },
    } = event;
    setScoreAuditVal(event.target.value);
    if (
      event.target.value === "<" ||
      event.target.value === ">" ||
      event.target.value === "="
    ) {
      setScoreSelected(true);
    } else {
      setScoreSelected(false);
    }
  };


  const handleChangeScoreInput = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    setScoreInputVal(event.target.value);
  };

  const handlechangeUcidVal = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    const regex = /^[0-9]*$/;
    const value = typeof event.target.value === "string" ? event.target.value : "";
    if (regex.test(value) || value === "") {
      setUcidAuditVal(value);
    }
  };

  const handlechangeCallerIDVal = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    const regex = /^[0-9]*$/;
    const value = typeof event.target.value === "string" ? event.target.value : "";
    if (regex.test(value) || value === "") {
      setCallerIDAuditVal(value);
    }
  };

  const handleChangeAgentAudit = (selectedOptions: any) => {
    const fil = handleFilters(selectedOptions);
    setAgentAuditVal(fil);
  };

  const handleFilters = (selectedOptions: any): any[] => {
    let map: { [key: string]: any } = {};
    for (let item of selectedOptions) {
      map[item.value] = item;
    }
    const duplicateRemoved = Object.values(map);
    return Array.isArray(duplicateRemoved) ? duplicateRemoved : [];
  };

  const handleFilter = (event: { target: { value: any; }; }) => {
    const {
      target: { value },
    } = event;

    let map: { [key: string]: any } = {};

    for (let list of value) {
      map[Object.values(list).join("")] = list;
    }

    let duplicateRemoved: any[] = [];
    value.forEach((item: { id: any; }) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) > 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });
    return duplicateRemoved;
  };


  const handleChangePage = (event: unknown, newPage: number) => {
    setTableData([]);
    setPage(newPage);
    setPageNav(true);
    var from = newPage === 0 ? 0 : newPage * rowsPerPage;
    var size = rowsPerPage;
    fetchOpenSearchCallsData(from);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTableData([]);
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  
    // fetchCalls(
    //     parseInt(event.target.value, 10),
    //   "0"
    // );
    fetchOpenSearchCallsData(0);
  };

  if (fetchCalls != undefined && fetchCalls.length != 0) {
    if (fetchCalls["Hits"] != undefined) {
      HitsArr = fetchCalls["Hits"];
    }
  }


  useEffect(() => {
    if(!pageNav){
      setPage(0);
    }
    setTableData(getData());
    setPageNav(false);
  }, [fetchCalls]);


  return (
<Container maxWidth="xl" style={{ marginTop: "20px" }}>
  <Grid container item spacing={2}>
                <div className="date-container">&nbsp;</div>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      renderInput={(props) => (
                        <TextField {...props} style={{ width: "124px" }} />
                      )}
                      disableFuture
                  
                      maxDate={endDateAudit ? moment(endDateAudit).toDate() : moment().toDate()}
                      label="Start Date"
                      value={startDateAudit}
                      onChange={(newValue) => {
                        handleFromDateChange(
                          String(moment(newValue).format("YYYY-MM-DD"))
                        );
                      }}
                    />
                  </LocalizationProvider>
                  <div></div>
                  <div className="date-container">&nbsp;</div>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      renderInput={(props) => (
                        <TextField {...props} style={{ width: "124px" }} />
                      )}
                      label="End Date"
                      value={endDateAudit}
                      disableFuture
                     
                      maxDate={moment().toDate()}
                    
                      minDate={startDateAudit ? moment(startDateAudit).toDate() : undefined}
                      onChange={(newValue) => {
                        handleToDateChange(
                          String(moment(newValue).format("YYYY-MM-DD"))
                        );
                      }}
                    />
                  </LocalizationProvider>
                  <div className="date-container">&nbsp;</div>
                  <FormControl variant="outlined" style={{ width: "125px" }}>
                    <MultiSelect
                      options={campaignAuditOptions}
                      value={campaignAuditVal}
                      onChange={handleChangeCampaignAudit}
                      labelledBy="Camapaign"
                      overrideStrings={{ selectSomeItems: "Campaigns" }}
                      hasSelectAll={true}
                      disableSearch={false} // Disable search functionality
                      ArrowRenderer={ArrowRenderer}
                      ClearIcon={<CustomClearIcon />}
                      ClearSelectedIcon={<CustomClearIcon />}
                      // className="CI-dashboaed-filters"
                    />
                  </FormControl>
                  <div className="date-container">&nbsp;</div>
                  <FormControl variant="outlined" style={{ width: "125px" }}>
                    <MultiSelect
                      options={agentAuditOptions}
                      value={agentAuditVal}
                      onChange={handleChangeAgentAudit}
                      labelledBy="Agents"
                      overrideStrings={{ selectSomeItems: "Agents" }}
                      hasSelectAll={true}
                       disableSearch={false} // Enable search functionality
                      ArrowRenderer={ArrowRenderer}
                      ClearIcon={<CustomClearIcon />}
                      ClearSelectedIcon={<CustomClearIcon />}
                      // className="CI-dashboaed-filters"
                    />
                  </FormControl>                 
                  <div className="date-container">&nbsp;</div>
                  <FormControl variant="outlined" style={{ width: "125px" }}>
                    <MultiSelect
                      options={dispositionAuditOptions}
                      value={dispositionAuditVal}
                      onChange={handleChangeDispositionAudit}
                      labelledBy="Disposition"
                      overrideStrings={{ selectSomeItems: "Dispositions" }}
                      hasSelectAll={true}
                       disableSearch={false}// Enable search functionality
                      ArrowRenderer={ArrowRenderer}
                      ClearIcon={<CustomClearIcon />}
                      ClearSelectedIcon={<CustomClearIcon />}
                      // className="CI-dashboaed-filters"
                    />
                  </FormControl>                  
                  <div className="date-container">&nbsp;</div>
                  <FormControl variant="outlined" style={{ width: "125px" }}>
                    <MultiSelect
                      options={skillOptions}
                      value={skillAuditVal}
                      onChange={handleChangeSkillAudit}
                      labelledBy="Skill"
                      overrideStrings={{ selectSomeItems: "Skills" }}
                      hasSelectAll={true}
                      disableSearch={false}// Enable search functionality
                      ArrowRenderer={ArrowRenderer}
                      ClearIcon={<CustomClearIcon />}
                      ClearSelectedIcon={<CustomClearIcon />}
                      // className="CI-dashboaed-filters"
                    />
                  </FormControl>                
                  <div className="date-container">&nbsp;</div>
                  <FormControl style={{ width: "125px" }}>
                    <InputLabel id="demo-multiple-language">
                      Language
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-language"
                      id="demo-multiple-checkbox"
                      multiple
                      value={languageAuditVal}
                      onChange={handleChangeLanguageAudit}
                      input={<OutlinedInput label="LanguageAudit" />}
                      renderValue={(selected) =>
                        selected.map((x) => x.value).join(", ")
                      }
                      MenuProps={MenuProps}
                    >
                      {languageAuditOptions.map((m) => (
                        <MenuItem key={m.label} value={m}>
                          <Checkbox
                            checked={
                              languageAuditVal.findIndex(
                                (item) => item.label === m.label
                              ) >= 0
                            }
                          />
                          <ListItemText primary={m.value} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="date-container">&nbsp;</div>
                  <FormControl variant="outlined" style={{ width: "125px" }}>
                    <MultiSelect
                      options={callTypeOptions}
                      value={callTypeAuditVal}
                      onChange={handleChangeCallTypeAudit}
                      labelledBy="Call-Type"
                      overrideStrings={{ selectSomeItems: "Call-Types" }}
                      hasSelectAll={true}
                       disableSearch={false} // Enable search functionality
                      ArrowRenderer={ArrowRenderer}
                      ClearIcon={<CustomClearIcon />}
                      ClearSelectedIcon={<CustomClearIcon />}
                      // className="CI-dashboaed-filters"
                    />
                  </FormControl> 
                  <div className="date-container">&nbsp;</div>
                  <FormControl style={{ width: "125px" }}>
                    <InputLabel id="demo-multiple-score">Score</InputLabel>
                    <Select
                      labelId="demo-score"
                      id="demo-checkbox"
                      value={scoreAuditVal}
                      // multiple
                      onChange={handleChangeScoreAudit}
                      input={<OutlinedInput label="Score" />}
                      renderValue={(selected) => selected}
                      MenuProps={MenuProps}
                    >
                      {scores.map((m: string, idx: number) => (
                        <MenuItem key={m} value={m}>
                          <Checkbox checked={scoreAuditVal.indexOf(m) > -1} />
                          <ListItemText primary={m} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="date-container">&nbsp;</div>
                  {scoreSelected ? (
                    <div>
                      <Box
                        component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: 98 },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <Input
                          style={{ fontSize: "0.8rem" }}
                          placeholder="Enter Score"
                          value={scoreInputVal}
                          onChange={handleChangeScoreInput}
                        />
                      </Box>
                    </div>
                  ) : (
                    <Grid></Grid>
                  )}
                 
                  <div className="date-container">&nbsp;</div>
                  <FormControl style={{ width: "125px" }}>
                    <InputLabel id="demo-multiple-score">Fatal Score</InputLabel>
                    <Select
                      labelId="demo-score"
                      id="demo-checkbox"
                      value={fatalAuditVal}
                      // multiple
                      onChange={handleChangeFatalAudit}
                      input={<OutlinedInput label="Fatal Score" />}
                      renderValue={(selected) => selected}
                      MenuProps={MenuProps}
                    >
                      {scores.map((m: string, idx: number) => (
                        <MenuItem key={m} value={m}>
                          <Checkbox checked={fatalAuditVal.indexOf(m) > -1} />
                          <ListItemText primary={m} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="date-container">&nbsp;</div>
                  {fatalScoreSelected ? (
                    <div>
                      <Box
                        component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: 98 },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <Input
                          style={{ fontSize: "0.8rem" }}
                          placeholder="Enter fatal Score"
                          value={fatalInputVal}
                          onChange={handleChangeFatalInput}
                        />
                      </Box>
                    </div>
                  ) : (
                    <Grid></Grid>
                  )}


                  <FormControl style={{ width: "125px" }}>
                    <div>
                      <Box
                        component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: 98 },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <Input
                          style={{ fontSize: "0.8rem" }}
                          placeholder="Enter CallerID"
                          value={callerIDAuditVal}
                          onChange={handlechangeCallerIDVal}
                          inputProps={{ pattern: "^[0-9]*$" }} // Only allow numbers
                        />
                      </Box>
                    </div>
                    </FormControl>
                    <FormControl style={{ width: "125px" }}>
                    <div>
                      <Box
                        component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: 98 },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <Input
                          style={{ fontSize: "0.8rem" }}
                          placeholder="Enter UCID"
                          value={ucidAuditVal}
                          onChange={handlechangeUcidVal}
                          inputProps={{ pattern: "^[0-9]*$" }} // Only allow numbers
                        />
                      </Box>
                    </div>

                  </FormControl>
                  <div className="date-container">&nbsp;</div>
                  <FormControl>
                    <Button
                      variant="contained"
                      style={{ padding: "13px 8px", fontSize: "0.8rem", marginLeft: "10px"  }}
                      onClick={() => {
                        fetchOpenSearchCallsData(0);
                      }}
                    >
                      Search
                    </Button>
                  </FormControl>

                  {load ? (
                    <div className="loader_digital" id="loader_digital"></div>
                  ) : null}
                </Grid>
                <div className="date-container">&nbsp;</div>
                <Grid item xs={12} style={{ marginLeft: "-13px" }}>


    <Card>
    {/* Box for RowsPerPage and Download button */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        ml: 100,
      }}
    >
      {/* RowsPerPage Options */}
      <TablePagination
    rowsPerPageOptions={[50, 100, 250]}
    component="div"
    count={
       fetchCalls && fetchCalls["dataCount"] > 0 ? fetchCalls["dataCount"] : 0
    } // This is what your request should be returning in addition to the current page of rows.
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
      />
  
      {/* Download Button */}
      <Button variant="contained" color="primary" onClick={handleDownload}>
        Download
      </Button>
    </Box>
  
    <Paper>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead sx={{ backgroundColor: "yellow" }}>
            <TableRow>
              {localStorage.getItem("user") === "hdfc_credila" ? (
                <>
                  {columns.map((column, accessor) => {
                    return (
                      <StyledTableCell
                        key={accessor}
                        align={column.align}
                        style={{
                          minWidth: column.minWidth,
                          backgroundColor: "#1976d2",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        {column.label}
                        {order === "asc" ? (
                          <img
                            alt="upArrow"
                            style={{ height: "12px", paddingLeft: "5px" }}
                            src={images.sortAsc}
                          />
                        ) : order == "" ? null : (
                          <img
                            alt="downArrow"
                            style={{ height: "12px" }}
                            src={images.sortDsc}
                          />
                        )}
                      </StyledTableCell>
                    );
                  })}
                </>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {localStorage.getItem("user") === "hdfc_credila" ? (
              <>
                {tableData &&
                  tableData.map((row: any, rowIdx: any) => {
                    return (
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={`${row.SNO}_${rowIdx}`}
                      >
                        {columns.map((column, keyId) => {
                          if (column.id === "audio_url") {
                            return (
                              <StyledTableCell
                                className="sub-color"
                                key={column.id + rowIdx + keyId}
                                align={column.align}
                              >
                                {audioFile(row.audio_url)}
                              </StyledTableCell>
                            );
                          }
                          if (column.id === "language") {
                            return (
                              <StyledTableCell
                                key={column.id + rowIdx + keyId}
                                align={column.align}
                              >
                                {getLanguageName(row[column.id])}
                              </StyledTableCell>
                            );
                          } else {
                            return (
                              <StyledTableCell
                                key={column.id + rowIdx + keyId}
                                align={column.align}
                              >
                                {row[column.id]}
                              </StyledTableCell>
                            );
                          }
                        })}
                      </StyledTableRow>
                    );
                  })}
              </>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  
    <Popover
      open={isPopoverOpen}
      onClose={handleOnPopoverClose}
      anchorReference="anchorPosition"
      anchorPosition={eleRefPoint}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      <span
        className="cs-modal-close"
        onClick={(e) => {
          handleOnPopoverClose();
        }}
      >
        X
      </span>
      {getPopoverContent()}
    </Popover>
  </Card>
  </Grid>
  </Container>
  
  );
}

function audioFile(url: string) {
  const aud = <audio controls controlsList="nodownload" src={url}></audio>;
  return aud;
}
